
import React, { useState, useEffect } from 'react'
import axios from 'axios';
import {baseUrl, dashboardLimit, milkType, shopFixCostCategory} from "../../comman/config.js";
import Loader from "../../comman/Loader";
import { PencilIcon, XCircleIcon } from '@heroicons/react/outline';
import {DateFilter} from "../../comman/DateFilter.js";
import { useNavigate, Link } from 'react-router-dom';
import Pagination from "react-js-pagination";

function Dashboard() {

    const [purchaseList, setPurchaseList] = useState([]);
    const [staffList, setStaffList] = useState([]);
    const [page, setPage] = useState(1);
    const [totalItem, setTotalItem] = useState(0);
    const [popupOpen, setPopupOpen] = useState(false);
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [totalPurchase, setTotalPurchase] = useState(0);
    const [totalSell, setTotalSell] = useState(0);
    const [totalRemaingAmount, setTotalRemaingAmount] = useState(0);
    const [sellList, setSellList] = useState([]);
    const [sellPage, setSellPage] = useState(1);
    const [sellTotalItem, setSellTotalItem] = useState(0);
    const [name, setName] = useState('');

    const user_id = localStorage.getItem("userId");

    const navigate = useNavigate();

    useEffect(() => {
        getStaffList();
        getRemainingDetail();
    }, []);
    useEffect(() => {
        if(fromDate && toDate){
            getPurchaseDetail();
        }
        
    }, [page, fromDate,toDate, staffList, name]);

    useEffect(() => {
        if(fromDate && toDate){
            getSellDetail();
        }
        
        
    }, [sellPage, fromDate,toDate, name]);

    const getStaffList = async (e) => {
        setPopupOpen(true);
        const response = await axios.get(`${baseUrl}/shop_salary/staff_list?user_id=${user_id}`);
        setStaffList(response.data.data);
        setPopupOpen(false);
    }

    const handlePageChange  = (pageNumber) => {
        setPage(pageNumber);
    }
    const handleSellPageChange = (pageNumber) => {
        setSellPage(pageNumber);
    }

    const getPurchaseDetail = async () => {
        setPopupOpen(true);
        const response = await axios.get(`${baseUrl}/shop_dashboard/purchase_list?page=${page}&limit=${dashboardLimit}&fromDate=${fromDate}&toDate=${toDate}&name=${name}&user_id=${user_id}`);
        setPopupOpen(false);
        const detailList = response.data.data;
        let result = [];
        
        if(detailList.length > 0){
            detailList.map((item) => {
                let obj = {
                    date : item.date
                };
                
                if(item.type === "shop_dairy_product"){
                    
                    obj.item = item.product_name;
                    obj.price = parseFloat(item.price) + parseFloat(item.other_price);
                }else if(item.type === "shop_fix_cost"){
                    const category = shopFixCostCategory.find((val) => val.value == item.category)?.label ?? "";
                    obj.item = category;
                    if(item.category == 1){
                        obj.price = parseFloat(item.rent_amount);
                    }else if(item.category == 2 || item.category == 5){
                        obj.price = parseFloat(item.bill_amount);
                    }else if(item.category == 3){
                        obj.price = parseFloat(item.material_amount);
                    }else if(item.category == 4){
                        obj.price = parseFloat(item.petrol_cost);
                    }else if(item.category == 6){
                        obj.price = parseFloat(item.other_amount);
                    }
                   
                }else if(item.type === "shop_purchase"){
                    if(item.product_type == 1){

                        obj.item = milkType.find((val) => val.value == item.milk_type)?.label ?? "";
                    }else{
                        obj.item = item.product_name;
                    }
                    obj.price = parseFloat(item.price);
                }else if (item.type === "shop_salary"){
                    obj.item = staffList.find((val) => val.id == item.staff_id)?.name ?? "";
                    obj.price = parseFloat(item.upaad);
                }
                result.push(obj);

            })
        }
        setTotalPurchase(response.data.purchaseTotal ?? 0);
        setPurchaseList(result);
        setTotalItem(response.data.totalItem);
    }

    const getSellDetail = async () => {
        setPopupOpen(true);
        const response = await axios.get(`${baseUrl}/shop_dashboard/sell_list?page=${sellPage}&limit=${dashboardLimit}&fromDate=${fromDate}&toDate=${toDate}&name=${name}&user_id=${user_id}`);
        setPopupOpen(false);
        setTotalSell(response.data.sellTotal ?? 0);
        setSellList(response.data.data);
        setSellTotalItem(response.data.totalItem);
    }

    const getRemainingDetail = async () => {
        setPopupOpen(true);
        const response = await axios.get(`${baseUrl}/shop_dashboard/remaining_amount`);
        setPopupOpen(false);
       
        if(response.data.data.length > 0){
            setTotalRemaingAmount(response.data.data?.[0]?.amount_value ?? 0)
        }
    }

    

    const handelFilterChange= (fromDate, toDate, clear, today, name) => {
        if(clear){
            setFromDate(today);
            setToDate(today); 
            setName(name);
        }else{
            setFromDate(fromDate);
            setToDate(toDate); 
            setName(name);
        }
        
    };

    const getProuctName = (item) => {
       
        if(item.product_type == 1){
            return milkType.find((val) => val.value == item.milk_type)?.label ?? "-"
        }else{
            return item.product_name;
        }
    }


    return (
        
        <div className="p-4">
            {popupOpen && (
                     <Loader /> 
                ) }
            <div className="flex justify-between items-center py-4 px-6">
                <h1 className="text-lg sm:text-xl md:text-xl lg:text-xl xl:text-2xl font-bold">Dashboard</h1>
              
            </div>
            
            <div className="relative overflow-x-auto ">
    <DateFilter handleFilterChange={handelFilterChange} />
    <div className="mt-4 px-2 mb-4">
        <h3><strong>Remaining Amount: </strong>{parseFloat(totalRemaingAmount ?? 0).toFixed(2)}</h3>
    </div>
    
    <div className="mt-4 px-2 mb-4">
        <div className="border rounded-lg shadow p-4 ">
            {/* <strong className="text-lg">Totals</strong> */}
            <div className="flex justify-between mt-2 text-lg">
                <div className="text-gray-700">Total Purchase: 
                    <span className="font-bold text-green-600"> {totalPurchase}</span>
                </div>
                <div className="text-gray-700">Total Sell: 
                    <span className="font-bold text-green-600"> {totalSell}</span>
                </div>
                <div className={`font-bold ${totalSell - totalPurchase > 0 ? 'text-green-500' : 'text-red-500'}`}>
                    {totalSell - totalPurchase > 0 
                        ? `Profit: ${totalSell - totalPurchase}` 
                        : `Loss: ${totalPurchase - totalSell}`}
                </div>
            </div>
        </div>
    </div>
    <div className="flex justify-between">
      
        <div className="w-1/2 px-2">
            <div className="bg-white border rounded-lg shadow p-4 dark:bg-gray-800 dark:border-gray-700">
                <strong>Purchase</strong>
                <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 mt-2">
                    <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                        <tr>
                            <th scope="col" className="px-6 py-3 border">Date</th>
                            <th scope="col" className="px-6 py-3 border">Item</th>
                            <th scope="col" className="px-6 py-3 border">Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        {purchaseList.map((item, index) => (
                            <tr key={index} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">{item.date}</th>
                                <td className="px-6 py-4">{item.item}</td>
                                <td className="px-6 py-4">{item.price}</td> 

                            </tr>
                        ))}
                    </tbody>
                </table>
                {totalItem > dashboardLimit && (<Pagination
              activePage={page}
              itemsCountPerPage={dashboardLimit}
              totalItemsCount={totalItem}
              pageRangeDisplayed={5}
              onChange={handlePageChange.bind(this)}
            />)}
            </div>
        </div>

        <div className="w-1/2 px-2">
            <div className="bg-white border rounded-lg shadow p-4 dark:bg-gray-800 dark:border-gray-700">
                <strong>Sell</strong>
                
                <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 mt-2">
                    <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                        <tr >
                            <th scope="col" className="px-6 py-3 border">Date</th>
                            <th scope="col" className="px-6 py-3 border">Item</th>
                            <th scope="col" className="px-6 py-3 border">Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        {sellList.map((item, index) => (
                            <tr key={index} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">{item.date}</th>
                                <td className="px-6 py-4">{getProuctName(item)}</td>
                                <td className="px-6 py-4">{item.price}</td> 
                                
                            </tr>
                        ))}
                    </tbody>
                </table>
                {sellTotalItem > dashboardLimit && (<Pagination
              activePage={sellPage}
              itemsCountPerPage={dashboardLimit}
              totalItemsCount={sellTotalItem}
              pageRangeDisplayed={5}
              onChange={handleSellPageChange.bind(this)}
            />)}
            </div>
        </div>
    </div>
    
</div>

            
            {/* <div>
            <div className="flex justify-between items-center py-4 px-6">
                <h1 className="text-lg sm:text-xl md:text-xl lg:text-xl xl:text-2xl font-bold">Due Salary Dashboard</h1>
                
            </div> 
            <div className="relative overflow-x-auto shadow-md sm:rounded-lg"> */}
                
                {/* <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                    <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                        <tr>
                        <th scope="col" className="px-6 py-3 border">Month</th>
                        <th scope="col" className="px-6 py-3 border">Staff</th>
                        <th scope="col" className="px-6 py-3 border">Salary</th>
                        <th scope="col" className="px-6 py-3 border">Upaad</th>
                        <th scope="col" className="px-6 py-3 border">Due Salary</th>
                        </tr>
                       
                    </thead>
                    <tbody>
                    {sellList.map((item) => (
                        <tr key={item.id} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                            <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">{item.month}</th>
                            <td className="px-6 py-4">{item.name}</td>
                            <td className="px-6 py-4">{item.salary}</td>
                            <td className="px-6 py-4">{item.total_upaad}</td> 
                            <td className="px-6 py-4">{(item.salary - item.total_upaad).toFixed(2)}</td> 
                           
                            
                        </tr>))}
           
                    </tbody>
                </table> */}
            {/* </div> */}
            {/* {sellTotalItem > limit && (<Pagination
              activePage={sellPage}
              itemsCountPerPage={limit}
              totalItemsCount={sellTotalItem}
              pageRangeDisplayed={5}
              onChange={handleSellPageChange.bind(this)}
            />)} */}
            {/* </div> */}
        </div>
        
  );
}

export default Dashboard;